import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Instructor } from 'src/app/model/instructor.model';
import { InstructorService } from 'src/app/service/instructor.service';
import { MatDialog } from '@angular/material';
import { LessonType } from 'src/app/model/lesson-type.model';
import { DeleteConfirmationDialog } from '../../delete-confirmation/delete-confirmation.dialog';
import { DataService } from 'src/app/service/data.service';

@Component({
  selector: 'app-lesson-type',
  templateUrl: './lesson-type.component.html',
  styleUrls: ['./lesson-type.component.css']
})
export class LessonTypeComponent implements OnInit {
  @Input() instructor: Instructor;
  canRemove = true;
  lessonTypes: LessonType[];
  addDialogRef: MatDialog;
  selectedLessonType: LessonType;

  constructor(public dialog: MatDialog, private instructorService: InstructorService, private dataService: DataService) {}

  ngOnInit() {
    this.dataService.getlessonTypes().subscribe(data=>{
      this.lessonTypes=data as LessonType[];
    })
  }

  getLessonTypes(): LessonType[] {
    return this.lessonTypes.filter(item => !this.instructor.lessonTypes.some(lt => lt.id === item.id));
  }

  remove(lessonType: LessonType) {
    const index = this.instructor.lessonTypes.indexOf(lessonType, 0);
    if (index > -1) {
      const dialogRef = this.dialog.open(DeleteConfirmationDialog, {
        width: '300px',
        data: {
          title: `DELETE ${lessonType.name}`,
          message: `Are you sure you want to remove ${lessonType.name}`,
          key: '',
          enterKeyToConfirm: false
        }
      });

      dialogRef.afterClosed().subscribe(result => {
        if (result) {
          this.removeLessonType(lessonType);
        }
      });
    }
  }

  removeLessonType(lessonType: LessonType) {
    if (this.instructor.user.id > 0) {
      this.instructorService.deleteLessonType(this.instructor.user.id, lessonType.id).subscribe(data => {
        if (data) {
          this.instructor.lessonTypes = data as LessonType[];
        }
      });
    } else {
      const index = this.instructor.lessonTypes.indexOf(lessonType);
      if (index >= 0) {
        this.instructor.lessonTypes.splice(index, 1);
      }
    }
  }

  add(lessonTypeSelectRef) {
    const dialogRef = this.dialog.open(lessonTypeSelectRef, {
      width: '250px'
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result && this.selectedLessonType != null) {
        this.addLessonType();
      }
    });
  }

  addLessonType() {
    if (this.instructor.user.id > 0) {
      this.instructorService.addLessonType(this.instructor.user.id, this.selectedLessonType.id).subscribe(data => {
        if (data) {
          this.instructor.lessonTypes = data as LessonType[];
        }
      });
    } else {
      this.instructor.lessonTypes.push(this.selectedLessonType);
    }
    this.selectedLessonType = null;
  }
}
